import { Set } from 'immutable';
import { App } from "../Enums/App";
import { AppView } from "../Enums/AppView";
import { IHeaderNavDisplay } from "../Models/IHeaderNavDisplay";
import { topNavHeightPx } from "../Constants/StyleConstants";
import {
    AppActionType,
    SET_APP_VIEW,
    SET_CURRENT_APP,
    SET_APP_PAST_INTRO,
    RESET_APP_PAST_INTRO,
    SHOW_HEADER_NAV,
} from "../Types/AppActionTypes";

export interface IAppReducerState {
  currentApp: App;
  appView: AppView;
  appsPastIntro: Set<App>;
  headerNavDisplay: IHeaderNavDisplay;
}

export const appReducerState: IAppReducerState = {
    currentApp: null,
    appView: AppView.Map,
    appsPastIntro: Set([App.Scout]),
    headerNavDisplay: {
        headerDisplay: "none",
        contentHeight: "100vh",
    },
};

export const appReducer = (
    state: IAppReducerState = { ...appReducerState },
    action: AppActionType
): IAppReducerState => {
    switch (action.type) {
    /** misc */
        case SET_CURRENT_APP: {
            return {
                ...state,
                currentApp: action.data as App,
            };
        }
        case SET_APP_VIEW: {
            return {
                ...state,
                appView: action.data as AppView,
            };
        }
        case SET_APP_PAST_INTRO: {
            return {
                ...state,
                appsPastIntro: state.appsPastIntro.add(action.data as App),
            };
        }
        case RESET_APP_PAST_INTRO: {
            return {
                ...state,
                appView: AppView.Map,
                appsPastIntro: state.appsPastIntro.delete(action.data as App),
            };
        }
        case SHOW_HEADER_NAV: {
            return {
                ...state,
                headerNavDisplay: {
                    headerDisplay: action.data ? "initial" : "none",
                    contentHeight: action.data ? `calc(100vh - ${topNavHeightPx}px)` : "100vh",
                }
            };
        }
        default: {
            return state;
        }
    }
};
